import { EyeIcon, PencilIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { useEffect } from "react";
import StaffNav from "./managernav";
import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import React from 'react';
import JSXParser from 'react-jsx-parser';
import { format } from "date-fns";
import { ArrowUpIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import JsxParser from 'react-jsx-parser';
import { useRef } from 'react';
import TaskTraining from "./tasktraining";




// Convert JSX to string









export default function EditHome() {
  const [buildModal, setBuildModal] = useState(false);
  const [preview, setPreview] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedOption, setSelectedOption] = useState("Design");
  const [selectedColor, setSelectedColor] = useState("text-gray-900");
  const [AIcolor, setAIcolor] = useState("text-gray-900");
  const [AIPrompt, setAIPrompt] = useState("");
  const [openAI, setOpenAI] = useState(null);
  const [loading, setLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [aiImage, setAiImage] = useState("");
  const [dataSource, setDataSource] = useState("");
  const [page, setPage] = useState(1);
  const [suggestions, setTrainingSuggestion] = useState(false);
  

  const token = localStorage.getItem('token');

  


const targetRef = useRef(null);


const scrollToTarget = () => {
  if (targetRef.current) {
    targetRef.current.scrollIntoView({ behavior: 'smooth' });
  }
};



    const [paragraph2, setParagraph2] = useState(
    ""
    );

    const [paragraph3, setParagraph3] = useState(
    ""
    );


  // State for the editable content
  const [heading, setHeading] = useState("");
  const [paragraph, setParagraph] = useState(
    ""
  );

  // State for styles
  const [headingColor, setHeadingColor] = useState("text-blue-700");
  const [paragraphColor, setParagraphColor] = useState("text-gray-600");
  const [bgColor, setBgColor] = useState("bg-white");
  const [bgImageUrl, setBgImageUrl] = useState("");
  const [font, setFont] = useState("sans-serif");
  const [renderedComponent, setRenderedComponent] = useState(null);
  const [prices, setPrices] = useState([]);
  const [showTemplateSelection, setShowTemplateSelection] = useState(true);
  const [trainingDocuments, setTrainingDocuments] = useState([]);
  const [newDoc, setNewDoc] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [NewTrainingDocName, setNewTrainingDocName] = useState("");
  const [existingDoc, setExistingDoc] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [content, setContent] = useState("");
  const [ video, setVideo] = useState("");
  const [aiTaskData, setAiTaskData] = useState([]);

  console.log("NewTrainingDocName", existingDoc);

  console.log(newDoc)

  console.log(prices)

  console.log("dataSource", dataSource);

  
  



  const templates = [
    {
      id: null,
      name: "None",
      code: "",
    },
    {
      id: 1,
      name: "Header Section",
      code: (
        <div className={`relative isolate overflow-hidden ${bgColor} px-6 py-24 sm:py-32 lg:px-8`}>
        {/* Background Image */}
        <img
          alt=""
          src={bgImageUrl}
          className="absolute inset-0 -z-10 size-full object-cover"
        />
  
        {/* Animated Heading with Blurred Background */}
        <div className="mx-auto max-w-2xl text-center animate-slide-in">
          <div className="inline-block px-6 py-4 rounded-lg shadow-md 
            bg-gradient-to-r from-white/5 to-white/20 
            backdrop-blur-sm text-transparent bg-clip-text">
            <h2
              className={`text-5xl font-semibold tracking-tight ${headingColor} sm:text-7xl`}
              style={{ fontFamily: font }}
            >
              {heading}
            </h2>
          </div>
        </div>
      </div>
      ),
    },
    {
        id: 2,
        name: "Feature Section",
        code: (
                <div className="relative">
                  <div className={`relative h-80 overflow-hidden ${bgColor} md:absolute md:left-0 md:h-full md:w-1/3 lg:w-1/2`}>
  <img
    alt=""
    src={bgImageUrl}
    className="h-full w-full object-cover"
  />
</div>

                  <div className="relative mx-auto max-w-7xl py-24 sm:py-32 lg:px-8 lg:py-40">
                    <div className="pl-6 pr-6 md:ml-auto md:w-2/3 md:pl-16 lg:w-1/2 lg:pl-24 lg:pr-0 xl:pl-32">
                      <h2 className={`text-base font-semibold leading-7 ${headingColor}`} style={{ fontFamily: font }}>
                        {heading}
                      </h2>
                      <p className={`mt-2 text-3xl font-bold tracking-tight sm:text-4xl ${paragraphColor} `} style={{ fontFamily: font }}>
                        {paragraph}
                      </p>
                     
                    </div>
                  </div>
                </div>
              
        ),
    },
    {
        id:3,
        name: "3 Paragraph Section",
        code: (
<div
  className={`${bgColor} py-12 sm:py-16 border-4 rounded-lg`}
  style={{
    borderImage: "linear-gradient(to right, #6366F1 10%, #0EA5E9 30%, #10B981 90%) 1",
    borderImageSlice: 1,
  }}
>
            <p className={`text-sm font-semibold text-center animate-slide-in ${headingColor}`}>
  {newDoc.TrainingDocName}
</p>
<h3 className={`text-2xl font-semibold text-center animate-slide-in animate-bounce ${headingColor}`}>
 {heading}
</h3>

          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            {/* Top-left logo */}
            <div className="relative flex items-center mb-8 animate-slide-in">
              <img
                alt="Logo"
                src={bgImageUrl}
                className="h-16 w-16 object-contain" /* Adjusted size for a small logo */
              />
            </div>
        
            {/* Content Section */}
            <div className="space-y-8">
              {/* Paragraph 1 */}
              <div className="border p-6 rounded-lg bg-white shadow-md">
                <p className={`mt-2 text-base leading-7 animate-slide-in ${paragraphColor}`} style={{ fontFamily: font }}>
                • {paragraph}
                </p>
              </div>
        
              {/* Paragraph 2 */}
              <div className="border p-6 rounded-lg bg-white shadow-md">
                <p className={`mt-2 text-base leading-7 animate-slide-in ${paragraphColor}`} style={{ fontFamily: font }}>
                • {paragraph2}
                </p>
              </div>
        
              {/* Paragraph 3 */}
              <div className="border p-6 rounded-lg bg-white shadow-md">
                <p className={`mt-2 text-base leading-7 animate-slide-in ${paragraphColor}`} style={{ fontFamily: font }}>
                • {paragraph3}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        
          
        ),
      },
    {

        id: 4,
        name: "Paragraph Section",
        code: (
          <div className={`${bgColor} py-12 sm:py-16`}>
  {/* Document Title */}
  <p className={`text-sm font-semibold text-center animate-slide-in ${headingColor}`}>
    {newDoc.TrainingDocName}
  </p>

  {/* Heading */}
  <h3 className={`text-2xl font-semibold text-center animate-slide-in animate-bounce ${headingColor}`}>
    {heading}
  </h3>

  {/* Main Content */}
  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    {/* Top-left logo */}
    <div className="relative flex items-center mb-8 animate-slide-in">
      <img
        alt="Logo"
        src={bgImageUrl}
        className="h-16 w-16 object-contain"
      />
    </div>

    {/* Combined Paragraph */}
    <div className="border p-6 rounded-lg bg-white shadow-md">
      <p
        className={`mt-2 text-base leading-7 animate-slide-in ${paragraphColor}`}
        style={{ fontFamily: font }}
      >
        {paragraph} 
      </p>
    </div>
  </div>
</div>
        ),
    },
    {
id : 5,
name: "Video Section",
code: (
  <div className="relative w-full bg-black">
  {/* Heading */}
  <div className="absolute inset-x-0 top-8 text-center z-10">
    <h2 className="text-4xl sm:text-6xl font-bold text-white">
      {heading}
    </h2>
  </div>

  {/* Video Background */}
  <div className="relative w-full h-screen">
    {video && video.trim() !== "" && ( // Check if the video URL is not blank
      <iframe
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${video}`}
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    )}
    {!video && (
      <div className="w-full h-full flex items-center justify-center text-white">
        <p>Please enter a valid YouTube video URL</p>
      </div>
    )}
  </div>
  {/* Overlay */}
  <div className="absolute inset-0 bg-black/40 pointer-events-none"></div>
</div>


),

    },



    

                
  ];

  console.log(newDoc)
  const handleInputChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case "heading":
        setHeading(value);
        break;
      case "paragraph":
        setParagraph(value);
        break;
        case "paragraph2":
        setParagraph2(value);
        break;
        case "paragraph3":
        setParagraph3(value);
        break;
      case "headingColor":
        setHeadingColor(value);
        break;
      case "paragraphColor":
        setParagraphColor(value);
        break;
      case "bgColor":
        setBgColor(value);
        break;
      case "bgImageUrl":
        setBgImageUrl(value);
        break;
      case "font":
        setFont(value);
        break;
      
      default:
        break;
    }
  };

  const tailwindColors = [
    // Gray colors
    "text-black", "text-white","text-gray-50", "text-gray-100", "text-gray-200", "text-gray-300", "text-gray-400", "text-gray-500", 
    "text-gray-600", "text-gray-700", "text-gray-800", "text-gray-900", 
    "bg-gray-50", "bg-gray-100", "bg-gray-200", "bg-gray-300", "bg-gray-400", "bg-gray-500", 
    "bg-gray-600", "bg-gray-700", "bg-gray-800", "bg-gray-900",
  
    // Red colors
    "text-red-50", "text-red-100", "text-red-200", "text-red-300", "text-red-400", "text-red-500", 
    "text-red-600", "text-red-700", "text-red-800", "text-red-900", 
    "bg-red-50", "bg-red-100", "bg-red-200", "bg-red-300", "bg-red-400", "bg-red-500", 
    "bg-red-600", "bg-red-700", "bg-red-800", "bg-red-900",
  
    // Yellow colors
    "text-yellow-50", "text-yellow-100", "text-yellow-200", "text-yellow-300", "text-yellow-400", "text-yellow-500", 
    "text-yellow-600", "text-yellow-700", "text-yellow-800", "text-yellow-900", 
    "bg-yellow-50", "bg-yellow-100", "bg-yellow-200", "bg-yellow-300", "bg-yellow-400", "bg-yellow-500", 
    "bg-yellow-600", "bg-yellow-700", "bg-yellow-800", "bg-yellow-900",
  
    // Green colors
    "text-green-50", "text-green-100", "text-green-200", "text-green-300", "text-green-400", "text-green-500", 
    "text-green-600", "text-green-700", "text-green-800", "text-green-900", 
    "bg-green-50", "bg-green-100", "bg-green-200", "bg-green-300", "bg-green-400", "bg-green-500", 
    "bg-green-600", "bg-green-700", "bg-green-800", "bg-green-900",
  
    // Blue colors
    "text-blue-50", "text-blue-100", "text-blue-200", "text-blue-300", "text-blue-400", "text-blue-500", 
    "text-blue-600", "text-blue-700", "text-blue-800", "text-blue-900", 
    "bg-blue-50", "bg-blue-100", "bg-blue-200", "bg-blue-300", "bg-blue-400", "bg-blue-500", 
    "bg-blue-600", "bg-blue-700", "bg-blue-800", "bg-blue-900",
  
    // Indigo colors
    "text-indigo-50", "text-indigo-100", "text-indigo-200", "text-indigo-300", "text-indigo-400", "text-indigo-500", 
    "text-indigo-600", "text-indigo-700", "text-indigo-800", "text-indigo-900", 
    "bg-indigo-50", "bg-indigo-100", "bg-indigo-200", "bg-indigo-300", "bg-indigo-400", "bg-indigo-500", 
    "bg-indigo-600", "bg-indigo-700", "bg-indigo-800", "bg-indigo-900",
  
    // Purple colors
    "text-purple-50", "text-purple-100", "text-purple-200", "text-purple-300", "text-purple-400", "text-purple-500", 
    "text-purple-600", "text-purple-700", "text-purple-800", "text-purple-900", 
    "bg-purple-50", "bg-purple-100", "bg-purple-200", "bg-purple-300", "bg-purple-400", "bg-purple-500", 
    "bg-purple-600", "bg-purple-700", "bg-purple-800", "bg-purple-900",
  
    // Pink colors
    "text-pink-50", "text-pink-100", "text-pink-200", "text-pink-300", "text-pink-400", "text-pink-500", 
    "text-pink-600", "text-pink-700", "text-pink-800", "text-pink-900", 
    "bg-pink-50", "bg-pink-100", "bg-pink-200", "bg-pink-300", "bg-pink-400", "bg-pink-500", 
    "bg-pink-600", "bg-pink-700", "bg-pink-800", "bg-pink-900",
  
    // Orange colors
    "text-orange-50", "text-orange-100", "text-orange-200", "text-orange-300", "text-orange-400", "text-orange-500", 
    "text-orange-600", "text-orange-700", "text-orange-800", "text-orange-900", 
    "bg-orange-50", "bg-orange-100", "bg-orange-200", "bg-orange-300", "bg-orange-400", "bg-orange-500", 
    "bg-orange-600", "bg-orange-700", "bg-orange-800", "bg-orange-900",
  
    // Cyan colors
    "text-cyan-50", "text-cyan-100", "text-cyan-200", "text-cyan-300", "text-cyan-400", "text-cyan-500", 
    "text-cyan-600", "text-cyan-700", "text-cyan-800", "text-cyan-900", 
    "bg-cyan-50", "bg-cyan-100", "bg-cyan-200", "bg-cyan-300", "bg-cyan-400", "bg-cyan-500", 
    "bg-cyan-600", "bg-cyan-700", "bg-cyan-800", "bg-cyan-900",
  
    // Teal colors
    "text-teal-50", "text-teal-100", "text-teal-200", "text-teal-300", "text-teal-400", "text-teal-500", 
    "text-teal-600", "text-teal-700", "text-teal-800", "text-teal-900", 
    "bg-teal-50", "bg-teal-100", "bg-teal-200", "bg-teal-300", "bg-teal-400", "bg-teal-500", 
    "bg-teal-600", "bg-teal-700", "bg-teal-800", "bg-teal-900",
  
    // Lime colors
    "text-lime-50", "text-lime-100", "text-lime-200", "text-lime-300", "text-lime-400", "text-lime-500", 
    "text-lime-600", "text-lime-700", "text-lime-800", "text-lime-900", 
    "bg-lime-50", "bg-lime-100", "bg-lime-200", "bg-lime-300", "bg-lime-400", "bg-lime-500", 
    "bg-lime-600", "bg-lime-700", "bg-lime-800", "bg-lime-900",
  
    // Emerald colors
    "text-emerald-50", "text-emerald-100", "text-emerald-200", "text-emerald-300", "text-emerald-400", "text-emerald-500", 
    "text-emerald-600", "text-emerald-700", "text-emerald-800", "text-emerald-900", 
    "bg-emerald-50", "bg-emerald-100", "bg-emerald-200", "bg-emerald-300", "bg-emerald-400", "bg-emerald-500", 
    "bg-emerald-600", "bg-emerald-700", "bg-emerald-800", "bg-emerald-900",
  
    // Rose colors
    "text-rose-50", "text-rose-100", "text-rose-200", "text-rose-300", "text-rose-400", "text-rose-500", 
    "text-rose-600", "text-rose-700", "text-rose-800", "text-rose-900", 
    "bg-rose-50", "bg-rose-100", "bg-rose-200", "bg-rose-300", "bg-rose-400", "bg-rose-500", 
    "bg-rose-600", "bg-rose-700", "bg-rose-800", "bg-rose-900",
  
    // Fuchsia colors
    "text-fuchsia-50", "text-fuchsia-100", "text-fuchsia-200", "text-fuchsia-300", "text-fuchsia-400", "text-fuchsia-500", 
    "text-fuchsia-600", "text-fuchsia-700", "text-fuchsia-800", "text-fuchsia-900", 
    "bg-fuchsia-50", "bg-fuchsia-100", "bg-fuchsia-200", "bg-fuchsia-300", "bg-fuchsia-400", "bg-fuchsia-500", 
    "bg-fuchsia-600", "bg-fuchsia-700", "bg-fuchsia-800", "bg-fuchsia-900",
  ];

  const handleChoose = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case "selectedOption":
        setSelectedOption(value);
        setRenderedComponent(null);
        setPreview(false);
        break;
      default:
        break;
    }
  }

  const handleAIEndpoint = async (selectedTemplateId, AIcolor, AIPrompt, aiImage, dataSource, aiTaskData) => {
    console.log("AI generate", { AIPrompt, AIcolor, aiImage, dataSource });
  
    setPreview(false);
  
    // Find the template object based on the selectedTemplateId
    const selectedTemplate = templates.find(template => template.id === selectedTemplateId);
    if (!selectedTemplate) {
      console.error("Selected template not found!");
      return;
    }
  
    console.log("Selected Template Code:", selectedTemplate.code);
  
    setLoading(true);
    setShowTemplateSelection(false);
  
    // Find template string by ID instead of using React component
    const templateString = templateStrings.find(t => t.id === selectedTemplateId)?.code || '';
  
    const response = await fetch('https://api.insightos.co.uk/api/aigeneratetrainingdocs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        AIPrompt,
        AIcolor,
        aiImage,
        dataSource,
        aiTaskData,
        selectedTemplate: { code: templateString }, // Fix: Send as an object
      }),
    });
  
    const data = await response.json(); // Fix: Always parse response
  
    if (data.success) {
      console.log('AI generated successfully:', data.data);
      setRenderedComponent(<JSXParser jsx={data.data} />);
    } else {
      console.error('Failed to generate AI content');
    }
  
    setLoading(false);
  };
  









  
  

  

  




const handleSavePreview = async () => {
  try {
    // Prepare the data to save based on the presence of NewTrainingDocName
    const saveData = NewTrainingDocName
      ? {
          Code: renderedComponent.props.jsx, // Save the JSX string as the code
          Title: AIPrompt, // Assuming this is the name for the advert
          TrainingDocName: newDoc.TrainingDocName, // Use newTrainingDocName if provided
          Page: page,
          Content : content
           
        }
      : {
          Code: renderedComponent.props.jsx, // Save the JSX string as the code
          Title: AIPrompt, // Assuming this is the name for the advert
          TrainingDocName: newDoc.TrainingDocName, // Use the existing TrainingDocName
          Page: page,
          Content: content
        };

    // Send the data to the server
    const response = await fetch('https://api.insightos.co.uk/api/aipreview', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials : 'include',

      body: JSON.stringify(saveData),
    });

    if (response.ok) {
      console.log('Advert saved successfully');
      window.location.reload(); // Reload the page on success
    } else {
      console.error('Failed to save the advert');
    }
  } catch (error) {
    console.error('Error:', error);
  }
};



const templateStrings = [
  {
    id: 1,

    code: `
       <div className= "relative isolate overflow-hidden \${bgColor} px-6 py-24 sm:py-32 lg:px-8">
        <img
          alt="image"
          src=\${bgImageUrl}
          className="absolute inset-0 -z-10 size-full object-cover"
        />
  
        <div className="mx-auto max-w-2xl text-center animate-slide-in">
          <div className="inline-block px-6 py-4 rounded-lg shadow-md 
            bg-gradient-to-r from-white/5 to-white/20 
            backdrop-blur-sm">
            <h2
              className="text-5xl font-semibold tracking-tight \${headingColor} sm:text-7xl"
              style={{ fontFamily: \${font} }}
            >
              \${heading}
            </h2>
          </div>
        </div>
      </div>
     
    `,
  },
  {
    id: 2,
    code: `
      <div className="relative">
        <div className="relative h-80 overflow-hidden \${bgColor} md:absolute md:left-0 md:h-full md:w-1/3 lg:w-1/2">
          <img
            alt=""
            src=\${bgImageUrl}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative mx-auto max-w-7xl py-24 sm:py-32 lg:px-8 lg:py-40">
          <div className="pl-6 pr-6 md:ml-auto md:w-2/3 md:pl-16 lg:w-1/2 lg:pl-24 lg:pr-0 xl:pl-32">
            <h2 className="text-base font-semibold leading-7 \${headingColor}" style={{ fontFamily:  \${font} }}>
              \${heading}
            </h2>
            <p className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl \${paragraphColor}" style={{ fontFamily: \${font} }}>
              \${paragraph}
            </p>
          </div>
        </div>
      </div>
    `,
  },
  {
    id: 3,
    code: `
<div
  className= "\${bgColor} py-12 sm:py-16 border-4 rounded-lg"
  style={{
    borderImage: "linear-gradient(to right, #6366F1 10%, #0EA5E9 30%, #10B981 90%) 1",
    borderImageSlice: 1,
  }}
>>
  <p className="text-sm font-semibold text-center animate-slide-in \${headingColor}">
    \${doc}
  </p>
  <h3 className="text-2xl font-semibold text-center animate-bounce animate-slide-in \${headingColor}">
    \${heading}
  </h3>

  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    {/* Top-left logo */}
    <div className="relative flex items-center mb-8 animate-slide-in">
      <img
        alt="Logo"
        src=\${bgImageUrl}
        className="h-16 w-16 object-contain" /* Adjusted size for a small logo */
      />
    </div>

    {/* Content Section */}
    <div className="space-y-8">
      {/* Bullet Point 1 */}
      <div className="border p-6 rounded-lg bg-white shadow-md">
        <p className="mt-2 text-base leading-7 animate-slide-in \${paragraphColor}" style={{ fontFamily:  \${font} }}>
          • \${paragraph}
        </p>
      </div>

      {/* Bullet Point 2 */}
      <div className="border p-6 rounded-lg bg-white shadow-md">
        <p className="mt-2 text-base leading-7 animate-slide-in \${paragraphColor}" style={{ fontFamily: \${font} }}>
          • \${paragraph2}
        </p>
      </div>

      {/* Bullet Point 3 */}
      <div className="border p-6 rounded-lg bg-white shadow-md">
        <p className="mt-2 text-base leading-7 animate-slide-in \${paragraphColor}" style={{ fontFamily:  \${font} }}>
          • \${paragraph3}
        </p>
      </div>
    </div>
  </div>
</div>
`
,

  },
  {
id: 4,
code: `
<div className="\${bgColor} py-12 sm:py-16">
  <p className="text-sm font-semibold text-center animate-slide-in \${headingColor}">
    \${doc}
  </p>
  <h3 className="text-2xl font-semibold text-center animate-bounce animate-slide-in \${headingColor}">
    \${heading}
  </h3>

  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    {/* Top-left logo */}
    <div className="relative flex items-center mb-8 animate-slide-in">
      <img
        alt="Logo"
        src=\${bgImageUrl}
        className="h-16 w-16 object-contain" /* Adjusted size for a small logo */
      />
    </div>

    {/* Content Section */}
    <div className="space-y-8">
      {/* Single Paragraph Section */}
      <div className="border p-6 rounded-lg bg-white shadow-md">
        <p className="mt-2 text-base leading-7 animate-slide \${paragraphColor}" style={{ fontFamily:  \${font} }}>
          \${paragraph} 
        </p>
      </div>
    </div>
  </div>
</div>

`
  },
  {
    id: 5,
    code: `
    <div className="relative w-full bg-black">
    {/* Heading */}
    <div className="absolute inset-x-0 top-8 text-center z-10">
      <h2 className="text-4xl sm:text-6xl font-bold text-white">
        \${heading}
      </h2>
    </div>
    <div className="relative w-full h-screen">
        <iframe
          className="w-full h-full"
          src= "https://www.youtube.com/embed/\${video}"

          title="YouTube Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
     
    </div>
    <div className="absolute inset-0 bg-black/40 pointer-events-none"></div>
  </div>
    `
  }


];



  




console.log(selectedTemplateId)





const handleOwnDesign = async () => {
  try {
    const selectedTemplate = templateStrings.find(t => t.id === selectedTemplateId);
    console.log(selectedTemplate);
    if (!selectedTemplate) throw new Error('Template not found');

    // Check if the selected template requires video handling (assumed ID 5)
   

    // Replace placeholders in the template with actual values
    const filledTemplate = selectedTemplate.code
      .replace(/\${heading}/g, heading)
      .replace(/\${paragraph}/g, paragraph)
      .replace(/\${paragraph2}/g, paragraph2 || "")
      .replace(/\${paragraph3}/g, paragraph3 || "")
      .replace(/\${headingColor}/g, headingColor)
      .replace(/\${doc}/g, newDoc.TrainingDocName)
      .replace(/\${paragraphColor}/g, paragraphColor)
      .replace(/\${bgColor}/g, bgColor)
      .replace(/\${bgImageUrl}/g, `"${bgImageUrl}"`)
      .replace(/\${font}/g, font)
      .replace(/\${video}/g, video);  // Use the extracted video ID (if valid)

    // Prepare the data to save based on NewTrainingDocName
    const dataToSave = NewTrainingDocName
      ? {
          Code: filledTemplate, // Save the filled template as code
          Title: heading,
          TrainingDocName: newDoc.TrainingDocName, // Use NewTrainingDocName if available
          Page: page,
          Content: paragraph + ("") + paragraph2 + ("") + paragraph3,
        }
      : {
          Code: filledTemplate, // Save the filled template as code
          Title: heading,
          TrainingDocName: newDoc.TrainingDocName, // Use the existing TrainingDocName
          Page: page,
          Content: paragraph + ("") + paragraph2 + ("") + paragraph3,
        };

    // Send the data to the server
    const response = await fetch('https://api.insightos.co.uk/api/ownpreview', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials : 'include',
      body: JSON.stringify(dataToSave),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log('Successfully saved:', result);
    window.location.reload(); // Reload the page on success
  } catch (error) {
    console.error('Error saving design:', error);
    // Handle error feedback
  }
};




useEffect(() => {
  const fetchTrainingDocuments = async () => {
    try {
      const response = await fetch('https://api.insightos.co.uk/api/trainingdocuments', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      if (response.ok) {
        const data = await response.json();

        // Transform data: group by TrainingDocName
        const groupedData = data.data.reduce((acc, item) => {
          const { TrainingDocName, Title, Page, Code, Content, id } = item;

          // Initialize group if it doesn't exist
          if (!acc[TrainingDocName]) {
            acc[TrainingDocName] = { TrainingDocName, Pages: [], Content, id };
          }

          // Add current item to the Pages array
          acc[TrainingDocName].Pages.push({ Title, Page, Code, Content, id });

          return acc;
        }, {});

        // Convert grouped object back to an array and sort Pages by Page number
        const groupedArray = Object.values(groupedData).map((group) => ({
          ...group,
          Pages: group.Pages.sort((a, b) => a.Page - b.Page), // Sort Pages by Page number
        }));

        console.log(groupedArray); // Verify grouped and sorted data
        setTrainingDocuments(groupedArray);
      } else {
        console.error('Failed to fetch training documents');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  fetchTrainingDocuments();
}, []);


const handleDeletePage = async (docName, page) => {

  console.log("Delete Page", { docName, page });

  // find the id of the page to delete
  const pageToDelete = newDoc.Pages.find((p) => p.Page === page);

  console.log("Page to delete", pageToDelete.id);

  const pageId = pageToDelete.id;

  try {
    const response = await fetch('https://api.insightos.co.uk/api/deletepage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        

      },
      credentials: 'include',
      body: JSON.stringify({ pageId }),
    });

    if (response.ok) {
      console.log('Page deleted successfully');
      window.location.reload();
    }
  } catch (error) {
    console.error('Error:', error);
  }

};

const handleDeleteDocument = async (docName) => {

  console.log("Delete Document", { docName });


  try {

    const response = await fetch('https://api.insightos.co.uk/api/deletedocument', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ docName }),
    });

    if (response.ok) {
      console.log('Document deleted successfully');
      window.location.reload();
    }
  } catch (error) {
    console.error('Error:', error);
  }

};


const handleVideo = (e) => {
  const value = e.target.value;

  // Ensure the value is a valid YouTube URL
  try {
    const videoUrl = new URL(value);

    // Check if it's a valid YouTube URL and contains the "v" parameter
    if (videoUrl.hostname.includes("youtube.com")) {
      const videoId = videoUrl.searchParams.get("v");

      // If a valid video ID is found, set it
      if (videoId) {
        setVideo(videoId);
      } else {
        // If no video ID is found, clear the video state (optional)
        setVideo("");
      }
    } else {
      // If it's not a valid YouTube URL, clear the video state
      setVideo("");
    }
  } catch (error) {
    // In case of an invalid URL, clear the video state
    setVideo("");
  }
};






const handleBack = () => {

  setShowTemplateSelection(true);
  setRenderedComponent(null);
  setPreview(false);
}

const handleSendData = (data) => {
  setAiTaskData(data);
    console.log(data);

}







console.log(newDoc)
  




return (
    <>
    <StaffNav />
    <div data-component="training-doc-builder" className="mx-auto max-w-7xl p-4">
  {/* Header Section */}
  <div className="w-full bg-indigo-600 rounded-md shadow-md px-4 sm:px-6 py-3 sm:py-4 flex flex-wrap items-center gap-3 justify-between">
  {/* Left Section - Title */}
  

  {/* Middle Section - Controls */}
  <div className="flex flex-wrap items-center gap-2">
    {!NewTrainingDocName ? (
      <button
        data-component="training-doc-action"
        data-feature="start-new-document"
        onClick={() => setNewTrainingDocName(true)}
        className="inline-flex items-center rounded-md bg-white px-4 py-2 text-sm font-medium text-emerald-500 shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        New Training Document
      </button>
      // new input for the name 
      
    ) : (
      <button
        data-component="training-doc-action"
        data-feature="cancel-new-document"
        onClick={() => setNewTrainingDocName(false)}
        className="inline-flex items-center rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        Back
      </button>
      
    )}
    {NewTrainingDocName && (
      <div className="w-full sm:min-w-[200px] sm:max-w-xs">
        <label htmlFor="trainingDocName" className="block text-sm font-medium text-gray-900">
          Training Document Name
        </label>
        <input 
        data-component="training-doc-field"
        data-feature="document-name"
        id="trainingDocName"
        name="trainingDocName"
        type="text"
        value={newDoc.TrainingDocName}
        onChange={(e) => setNewDoc({ ...newDoc, TrainingDocName: e.target.value })}
        className="mt-1 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
        />
      </div>
    )}



    {collapsed && (
      <button
        data-component="training-doc-action"
        data-feature="expand-preview"
        onClick={() => setCollapsed(false)}
        className="inline-flex items-center rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
      >
        Expand
      </button>
    )}
  </div>

  {/* Right Section - Document Selection */}
  {!NewTrainingDocName && (
    <div className="flex flex-wrap items-center gap-2">
      <button
        data-component="training-doc-action"
        data-feature="cancel-selection"
        onClick={() => window.location.reload()}
        className="inline-flex items-center rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        Cancel
      </button>

      <div className="w-full sm:min-w-[200px] sm:max-w-xs">
        <label htmlFor="trainingDoc" className="block text-sm font-medium text-gray-900">
          Select Training Document
        </label>
        <select
          data-component="training-doc-field"
          data-feature="existing-document"
          id="trainingDoc"
          name="trainingDoc"
          onChange={(event) => {
            const selectedDoc = trainingDocuments.find(
              (doc) => doc.TrainingDocName === event.target.value
            );
            setNewDoc(selectedDoc);
          }}
          className="mt-1 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
        >
          <option value="">Select Training Document</option>
          {trainingDocuments.map((doc) => (
            <option key={doc.TrainingDocName} value={doc.TrainingDocName}>
              {doc.TrainingDocName}
            </option>
          ))}
        </select>
      </div>
    </div>
  )}
</div>

 
  {/* Main Content Grid */}
  <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
  {/* Document Preview Section */}
  {!collapsed && newDoc && newDoc.Pages && newDoc.Pages.length > 0 && (
    <div ref={targetRef} className="p-2 border rounded-md shadow-sm bg-gray-50">
      <div className="flex items-center justify-between mb-2">
        <button
          data-component="training-doc-preview-action"
          data-feature="collapse-preview"
          onClick={() => setCollapsed(true)}
          className="inline-flex items-center rounded bg-red-600 px-2 py-1 text-xs font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
        >
          <XMarkIcon className="h-4 w-4" aria-hidden="true" />
        </button>
        <h2 className="text-sm font-semibold text-gray-900">{newDoc.TrainingDocName}</h2>
        <p className="text-xs text-gray-500">
          Page: {currentPage + 1} / {newDoc.Pages.length}
        </p>
        <button
          data-component="training-doc-preview-action"
          data-feature="delete-document"
          onClick={() => handleDeleteDocument(newDoc.TrainingDocName)}
          className="inline-flex items-center rounded px-2 py-1 text-xs font-medium bg-red-500 text-white hover:bg-indigo-200"
        >
          Delete Document
        </button>
      </div>

      <div className="border p-2 bg-white rounded shadow-inner text-xs">
        <JsxParser jsx={newDoc.Pages[currentPage].Code} />
      </div>

      <div className="flex justify-between mt-2">
        <button
          data-component="training-doc-preview-action"
          data-feature="previous-page"
          onClick={() => currentPage > 0 && setCurrentPage((prev) => prev - 1)}
          disabled={currentPage === 0}
          className={`inline-flex items-center rounded px-2 py-1 text-xs font-medium ${
            currentPage === 0
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
          }`}
        >
          Previous
        </button>
        <button
          data-component="training-doc-preview-action"
          data-feature="delete-page"
          onClick={() => handleDeletePage(newDoc.TrainingDocName, newDoc.Pages[currentPage].Page)}
          className="inline-flex items-center rounded px-2 py-1 text-xs font-medium bg-red-500 text-white hover:bg-indigo-200"
        >
          Delete Page
        </button>
        
        <button
          data-component="training-doc-preview-action"
          data-feature="next-page"
          onClick={() =>
            currentPage < newDoc.Pages.length - 1 && setCurrentPage((prev) => prev + 1)
          }
          disabled={currentPage === newDoc.Pages.length - 1}
          className={`inline-flex items-center rounded px-2 py-1 text-xs font-medium ${
            currentPage === newDoc.Pages.length - 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  )}

  {/* Rendered Component Section */}
  {renderedComponent && (
    <div className="p-2 border rounded-md shadow-sm bg-gray-50">
      <h2 className="text-sm font-semibold text-gray-900">AI Component</h2>
      <p className="text-xs text-gray-500">Page: {page}</p>
      <div className="mt-2">{renderedComponent}</div>
    </div>
  )}

  {/* Preview Section */}
  {preview && selectedTemplateId && (
    <div className="p-2 border rounded-md shadow-sm bg-gray-50">
      <h2 className="text-sm font-semibold text-gray-900">Preview</h2>
      <p className="text-xs text-gray-500">Page: {page}</p>
      <div className="mt-2">{templates.find((t) => t.id === selectedTemplateId)?.code}</div>
    </div>
  )}
</div>

</div>

  <div className={`grid grid-cols-1 ${showTemplateSelection ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
    {/* Template Selection Section */}
    {showTemplateSelection && (
      <div className="col-span-1 p-4 border rounded-md shadow-sm bg-gray-50">
        <fieldset>
          <legend className="text-sm font-semibold leading-6 text-gray-900">Select a Template</legend>
          <div className="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200">
            {templates.map((template) => (
              <div key={template.id} className="relative flex items-start py-4">
                <div className="min-w-0 flex-1 text-sm leading-6">
                  <label htmlFor={`template-${template.id}`} className="select-none font-medium text-gray-900">
                    {template.name}
                  </label>
                </div>
                <div className="ml-3 flex h-6 items-center">
                  <input
                    data-component="training-template-option"
                    data-feature={`template-${template.id}`}
                    type="radio"
                    id={`template-${template.id}`}
                    name="template"
                    className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    onChange={() => setSelectedTemplateId(template.id)}
                  />
                </div>
              </div>
            ))}
          </div>
        </fieldset>
      </div>
    )}



    {/* Main Content Section (Design or AI Generate) */}
    <div className={`${showTemplateSelection ? 'md:col-span-2' : ''} p-4 border rounded-md shadow-sm bg-gray-50`}>
    {selectedTemplateId ? (
        <>
        {!collapsed && (
          <button
           data-component="training-doc-action"
           data-feature="scroll-to-preview"
           type="button"
           onClick={scrollToTarget}
             className="rounded-full animate-bounce bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
             >
        <ArrowUpIcon className="h-5 w-5" aria-hidden="true" />
      </button>
        )}
          <label htmlFor="options" className="block text-sm font-medium leading-6 text-gray-900">
            Choose An Option
          </label>
          <select
            data-component="training-doc-mode"
            data-feature="option-select"
            id="options"
            name="options"
            onChange={(e) => handleChoose(e, "selectedOption")}
            defaultValue="Design"
            className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
          >
            <option>Design</option>
            <option>Generate AI</option>
          </select>

          {/* Design Option Content */}

          {selectedOption === "Design" && (
            <div className="mt-4">
            
                              <h2 className="text-lg font-semibold">Adding To Training: {newDoc.TrainingDocName}</h2>
                              <div>
                              <label htmlFor="page" className="block text-sm/6 font-medium text-gray-900">
  Select Page
</label>
<select
  data-component="training-doc-page-select"
  data-feature="design-page"
  id="page"
  name="page"
  onChange={(event) => setPage(event.target.value)}
  value={page}
  className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm/6"
>
  <option value="" disabled>
    Choose a Page
  </option>

  {/* Check if newDoc and newDoc.Pages are defined before proceeding */}
  {newDoc && newDoc.Pages && Array.from({ length: 10 }, (_, i) => i + 1) // Assuming pages 1 to 10
    .filter((page) => !newDoc.Pages.some((doc) => doc.Page === page)) // Exclude pages already used
    .map((page) => (
      <option key={page} value={page}>
        Page {page}
      </option>
    ))}
</select>

</div>

  <div className="mt-4">
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Edit Heading</label>
                      <input
                        data-component="training-doc-field"
                        data-feature="heading"
                        type="text"
                        value={heading}
                        onChange={(e) => handleInputChange(e, "heading")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
  
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Edit Paragraph</label>
                      <textarea
                        data-component="training-doc-field"
                        data-feature="paragraph"
                        value={paragraph}
                        onChange={(e) => handleInputChange(e, "paragraph")}
                        rows="4"
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
  
                    {selectedTemplateId === 3 && (
                      <div className="mb-4">
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Edit Paragraph 2</label>
                        <textarea
                          data-component="training-doc-field"
                          data-feature="paragraph-2"
                          value={paragraph2}
                          onChange={(e) => handleInputChange(e, "paragraph2")}
                          rows="4"
                          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Edit Paragraph 3</label>
                      <textarea
                        data-component="training-doc-field"
                        data-feature="paragraph-3"
                        value={paragraph3}
                        onChange={(e) => handleInputChange(e, "paragraph3")}
                        rows="4"
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    </div>
                    )}

  
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select Heading Color</label>
                      <select
                        data-component="training-doc-field"
                        data-feature="heading-color"
                        value={headingColor}
                        onChange={(e) => handleInputChange(e, "headingColor")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      >
                        {tailwindColors.filter(color => color.startsWith('text-')).map((color) => (
                          <option key={color} value={color}>
                            {color}
                          </option>
                        ))}
                      </select>
                    </div>
  
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select Paragraph Color</label>
                      <select
                        data-component="training-doc-field"
                        data-feature="paragraph-color"
                        value={paragraphColor}
                        onChange={(e) => handleInputChange(e, "paragraphColor")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      >
                        {tailwindColors.filter(color => color.startsWith('text-')).map((color) => (
                          <option key={color} value={color}>
                            {color}
                          </option>
                        ))}
                      </select>
                    </div>
  
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select Background Color</label>
                      <select
                        data-component="training-doc-field"
                        data-feature="background-color"
                        value={bgColor}
                        onChange={(e) => handleInputChange(e, "bgColor")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      >
                        {tailwindColors.filter(color => color.startsWith('bg-')).map((color) => (
                          <option key={color} value={color}>
                            {color}
                          </option>
                        ))}
                      </select>
                    </div>
  {selectedTemplateId !== 5 && (
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Background Image URL (optional)</label>
                      <input
                        data-component="training-doc-field"
                        data-feature="background-image"
                        type="text"
                        value={bgImageUrl}
                        onChange={(e) => handleInputChange(e, "bgImageUrl")}
                        placeholder="Enter image URL"
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
  )}
                    <div className="mb-4">
                      {bgImageUrl && (
                        <img src={bgImageUrl} alt="Background" className="w-full h-32 object-cover rounded-md" />
                      )}
                    </div>
                    
                    {selectedTemplateId === 5 && (
                      <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">You Tube Video Url</label>
                      <input
                        data-component="training-doc-field"
                        data-feature="video-url"
                        type="text"
                        value={video}
                        onChange={(e) => handleVideo(e)}
                        placeholder="Enter YouTube URL"
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    
                      )}



  
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select Font Family</label>
                      <select
                        data-component="training-doc-field"
                        data-feature="font"
                        value={font}
                        onChange={(e) => handleInputChange(e, "font")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      >
                        <option value="sans-serif">Sans-serif</option>
                        <option value="serif">Serif</option>
                        <option value="monospace">Monospace</option>
                        <option value="cursive">Cursive</option>
                        <option value="fantasy">Fantasy</option>
                      </select>
                    </div>
  
                   
                  </div>              <button
                data-component="training-doc-action"
                data-feature="preview-template"
                onClick={() => setPreview(true)|| setShowTemplateSelection(false)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Preview
              </button>
            </div>
          )}

          {/* Generate AI Option Content */}
          {selectedOption === "Generate AI" && (
            <div className="mt-4">
              <button
               data-component="training-doc-action"
               data-feature="ai-back"
               type="button" onClick={() => handleBack()}
               className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Back
                </button>
              {/* AI generation inputs and settings */}
              <div className="mt-4">
              {selectedTemplateId === 5 && (
  <div className="mt-4">
    <h3 className="text-lg font-semibold text-red-600"> Video cannot be used in the AI Section Sorry! </h3>
  </div>
)}

              <div>
                              <label htmlFor="page" className="block text-sm/6 font-medium text-gray-900">
  Select Page
</label>
<select
  data-component="training-doc-page-select"
  data-feature="ai-page"
  id="page"
  name="page"
  onChange={(event) => setPage(event.target.value)}
  value={page}
  className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm/6"
>
  <option value="" disabled>
    Choose a Page
  </option>

  {/* Check if newDoc and newDoc.Pages are defined before proceeding */}
  {newDoc && newDoc.Pages && Array.from({ length: 10 }, (_, i) => i + 1) // Assuming pages 1 to 10
    .filter((page) => !newDoc.Pages.some((doc) => doc.Page === page)) // Exclude pages already used
    .map((page) => (
      <option key={page} value={page}>
        Page {page}
      </option>
    ))}
</select>

</div>


                <h2 className="text-lg font-semibold">Adding To Training: {newDoc.TrainingDocName}</h2>
                <p className="text-sm text-gray-900">Generate AI content based on the selected template.</p>
                <p className="text-sm text-gray-900">Provide a description and image URL for the AI to generate content, Contents Page, Introduction, Final Words.</p>
            <textarea
              data-component="training-doc-field"
              data-feature="ai-prompt"
              onChange={(e) => setAIPrompt(e.target.value)}
                placeholder="Describe your AI-generated content"
                className="block w-full mt-5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            <div className="mt-4">
                <textarea
                  data-component="training-doc-field"
                  data-feature="ai-image-url"
                  onChange={(e) => setAiImage(e.target.value)}
                    placeholder="Paste your image URL"
                    className="block w-full mt-5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
            </div>
            <div className="mt-4">  
                <label className="block text-sm font-medium text-gray-700">Use Previous Content as a guide</label>
                <select
                  data-component="training-doc-field"
                  data-feature="ai-data-source"
                  value={dataSource}
                  onChange={(e) => setDataSource(e.target.value)}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                >
                    <option value="">Select</option>
                    {newDoc && newDoc.Pages && newDoc.Pages.map((doc) => (
                        <option key={doc.Page} value={doc.Content}>
                            Page {doc.Page}
                        </option>
                    ))}
                </select>
            </div>
            {aiTaskData && Object.keys(aiTaskData).length > 0 && (
  <div className="mt-4 p-4 border rounded-md bg-gray-100">
    <h2 className="text-lg font-semibold">Selected Task Details:</h2>
    <p><strong>Task:</strong> {aiTaskData.task || "N/A"}</p>
    <p><strong>Count:</strong> {aiTaskData.count ?? "N/A"}</p>
    <p><strong>Role:</strong> {aiTaskData.role || "N/A"}</p>
    <p><strong>Issues:</strong> {aiTaskData.issues?.length > 0 ? aiTaskData.issues.join(", ") : "None"}</p>
    <p><strong>Help Suggestions:</strong> {aiTaskData.helpSuggestions?.length > 0 ? aiTaskData.helpSuggestions.join(", ") : "None"}</p>
  </div>
)}

                

            
            <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700">Color Scheme</label>
                <select
                  data-component="training-doc-field"
                  data-feature="ai-color"
                  value={AIcolor}
                  onChange={(e) => setAIcolor(e.target.value)}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                    style={{ backgroundColor: AIcolor }}
                >
                    {tailwindColors.map((color) => (
                      
                        <option key={color} value={color}>
                            {color}
                        </option>
                    ))}
                </select>
                <div className={`mt-5 mb-5 w-full h-10 ${AIcolor}`}></div>
            </div>

            {loading ? (
              <div className="flex items-center gap-x-2">
                <Cog6ToothIcon aria-hidden="true" className="-ml-0.5 h-20 w-20 text-blue-700 animate-spin" />
                <span className="text-lg font-semibold text-gray-900">Generating AI...</span>
              </div>
                
            ) : (
                <button
                  data-component="training-doc-action"
                  data-feature="generate-ai"
                  data-time-saved="45"
                  onClick={() => handleAIEndpoint(selectedTemplateId, AIcolor, AIPrompt, aiImage, dataSource)}
                  type="button"
                    className="inline-flex items-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    <Cog6ToothIcon aria-hidden="true" className="-ml-0.5 h-5 w-5 animate-ping" />
                    Generate AI
                </button>
            )}
        </div>
            </div>
          )}
        </>
      ) : (
        <p className="text-sm text-gray-900">Please select a template to continue.</p>
      )}
    </div>
             
          {/* Rendered AI Component */}
          {renderedComponent && (
      <div className={`${showTemplateSelection ? 'md:col-span-2' : ''} mt-4`}>
        {renderedComponent}
        <button
          data-component="training-doc-action"
          data-feature="save-preview"
          onClick={handleSavePreview}
          type="button"
          className="inline-flex mr-5 items-center gap-x-2 mt-4 rounded-md bg-green-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Save as Preview
        </button>
        <button
          data-component="training-doc-action"
          data-feature="cancel-preview"
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-x-2 mt-4 rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Cancel
        </button>
      </div>
    )}

    {/* Preview Section */}
    {preview && selectedTemplateId && (
  <div className={`${showTemplateSelection ? 'md:col-span-2' : ''} mt-4`}>
    <h2 className="text-lg font-semibold">Preview Section</h2>
    <div>
      {templates.find((t) => t.id === selectedTemplateId)?.code}
    </div>
    <div className="mt-4 flex gap-x-4">
      <button
        data-component="training-doc-action"
        data-feature="save-template-preview"
        onClick={handleOwnDesign}
        type="button"
        className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Save as Preview
      </button>
      <button
        data-component="training-doc-action"
        data-feature="cancel-template-preview"
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Cancel
      </button>
    </div>
  </div>
)}

  </div>
    </>
    );
}
